import comp from "./LearningManager";
export default comp;
